import React from "react";
const EditForm = ({
  editForm,
  onChange,
  onSubmit,
  onCancel,
  areas,
  loadingAreas,
}) => {
  // console.log(editForm)
  // console.log(areas)
  const handleChange = (e, isImage = false) => {
    const { name, value, files } = e.target;

    if (isImage) {
      onChange({ target: { name, value: files[0] } }, true);
    } else {
      onChange(e);
    }
  };
  return (
    <form
      onSubmit={onSubmit}
      className="grid grid-cols-2 gap-4 p-6 bg-white rounded-lg shadow-lg w-[90%] max-w-2xl"
    >
      {/* Name Product */}
      <div className="flex flex-col">
        <label className="text-sm font-semibold text-black capitalize">
          Name Product
        </label>
        <input
          type="text"
          name="name"
          value={editForm.name}
          onChange={handleChange}
          required
          className="px-3 py-1 text-black bg-gray-100 border rounded-md"
        />
      </div>

      {/* Price Product */}
      <div className="flex flex-col">
        <label className="text-sm font-semibold text-black capitalize">
          Price One Product
        </label>
        <input
          type="text"
          name="price"
          value={editForm.price}
          onChange={handleChange}
          required
          className="px-3 py-1 text-black bg-gray-100 border rounded-md"
        />
      </div>

      {/* DShippingFees Product */}
      <div className="flex flex-col">
        <label className="text-sm font-semibold text-black capitalize">
          Fees
        </label>
        <input
          type="text"
          name="DShippingFees"
          value={editForm.DShippingFees}
          onChange={handleChange}
          required
          className="px-3 py-1 text-black bg-gray-100 border rounded-md"
        />
      </div>

      {/* Image Upload Field */}
      <div className="flex flex-col">
        <label className="text-sm font-semibold text-black capitalize">
          Image
        </label>
        <input
          type="file"
          name="image"
          accept="image/*"
          onChange={(e) => handleChange(e, true)}
          className="px-3 py-1 text-black bg-gray-100 border rounded-md"
        />
      </div>

      {/* Area Dropdown */}
      <div className="flex flex-col">
        <label className="text-sm font-semibold text-black capitalize">
          Area
        </label>
        <select
          name="area"
          value={editForm.area}
          onChange={handleChange}
          required
          className="px-3 py-1 text-black bg-gray-100 border rounded-md"
        >
          <option value="" className="text-black">
            Select Area
          </option>
          {loadingAreas ? (
            <option disabled className="text-black">
              Loading areas...
            </option>
          ) : // Check if 'areas' is an array and not empty
          Array.isArray(areas) && areas.length > 0 ? (
            areas.map((area) => (
              <option key={area.id} value={area._id} className="text-black">
                {area.name.en}
              </option>
            ))
          ) : (
            <option disabled className="text-black">
              No areas available
            </option>
          )}
        </select>
      </div>

      <div className="flex justify-end col-span-2 mt-2 space-x-3">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-1 text-black bg-gray-300 rounded-md"
        >
          Cancel
        </button>
        <button
          type="submit"
          className="px-4 py-1 text-white rounded-md bg-custom-yellow"
        >
          Update
        </button>
      </div>
    </form>
  );
};

export default EditForm;
